import { FileUploaderModal } from '@library/components/modals/FileUploaderModal';
import type { QueryMutationError } from '@bo-types/common';
import { UploadCSVButton } from '@library/components/buttons/UploadCSVButton';
import { useState } from 'react';

export interface UploadCSVProps {
  className?: string;
  buttonText?: string;
  disabled?: boolean;
  handleFileUpload: (uploadFile: File | null) => Promise<void>;
  error: QueryMutationError;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isUninitialized: boolean;
  reset: () => void;
}

export const UploadCSV = ({
  className = '',
  buttonText = '',
  disabled = false,
  handleFileUpload,
  error,
  isError,
  isLoading,
  isSuccess,
  isUninitialized,
  reset
}: UploadCSVProps) => {
  const [showModal, setShowModal] = useState(false);

  const resetUploadAPI = () => {
    if (!isUninitialized) {
      reset();
    }
  };

  const handleCancelModal = () => {
    resetUploadAPI();
    setShowModal(false);
  };

  const handleUploadButtonClick = () => {
    setShowModal(true);
  };

  return (
    <div className={className} data-testid="UploadCSV">
      <UploadCSVButton
        disabled={disabled}
        handleOnClick={handleUploadButtonClick}
        buttonText={buttonText}
      />
      {showModal && (
        <FileUploaderModal
          active={showModal}
          onCancelModal={handleCancelModal}
          onFileUpload={handleFileUpload}
          isUploadError={isError}
          isUploading={isLoading}
          isUploadSuccess={isSuccess}
          resetUploadAPI={resetUploadAPI}
          uploadError={error}
        />
      )}
    </div>
  );
};
